export default {
    view: {
        type: String,
        default: 'contractor'
    }
}
